export const SWITCH_CHECKOUT_ACTIVE_ITEM = 'SWITCH_CHECKOUT_ACTIVE_ITEM';
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS';
export const GET_CURRENT_USER_FAILURE = 'GET_CURRENT_USER_FAILURE';
export const CLEAN_CHECKOUT_CONTENT_STORE = 'CLEAN_CHECKOUT_CONTENT_STORE';
export const LOAD_CLIENT_BY_PLATE = 'LOAD_CLIENT_BY_PLATE';
export const SET_CLIENT_CAR_PLATE = 'SET_CLIENT_CAR_PLATE';


// WEBPACK FOOTER //
// ./src/workflow/checkout/checkoutContent/types.js